<template>
  <div id="myElement" style="position: absolute; width: 100%; height: 100%; top: 0; background: #f0f3f7">
    <div class="digSHowBox" v-if="carmerShow">
      <div class="cameraBox">
        <div style="" class="box1">人脸认证核验</div>
        <div class="box2">为保证考试严肃，需本人进行人脸认证核验后才能继续考试学习</div>
        <div style="" class="bkBox box3">
          <div class="bk">
            <img class="box4" src="../../assets/examImgs/bk.png" alt="" />
          </div>
          <img v-if="showImg" :src="imgUrl" alt="" class="box5" />
          <video v-if="!showImg" class="box23" id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
          <canvas id="canvasCamera" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()" class="camerBtn">立即认证核验</div>
      </div>
    </div>

    <div class="header">
      <!-- <div
        @click="goBack"
        style="
          background: rgba(255, 255, 255, 0.15);
          width: 80px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          margin-top: 10px;
          border-radius: 30px;
          text-align: center;
        "
      >
        返回
      </div> -->
      <div class="time">错题库</div>
      <div class="timeBox">
        <div style="display: flex;align-items: center;margin-right: 20px;">
          <div>工种选择：</div>
        <el-select v-model="queryErrInfo.classCodeId" placeholder="请选择" style="margin-left: 15px; width: 260px" @change="handJob">
          <el-option v-for="item in jobCategoryList" :label="item.name" :value="item.id" :key="item.id"> </el-option>
        </el-select>
        </div>
        <el-date-picker
          @change="handlTime"
          v-model="timeAend"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        <el-select v-model="queryErrInfo.type" placeholder="请选择" style="margin-left: 15px" @change="handlTab">
          <el-option label="全部错题" value="03"> </el-option>
          <el-option label="题库错题" value="02"> </el-option>
          <el-option label="模拟错题" value="01"> </el-option>
        </el-select>
      </div>
      <div></div>
      

      <div style="display: flex">
        <div>{{ examInfo.userName }}</div>
        <div style="" class="box6"></div>
      </div>
    </div>

    <div class="examBanner">
      <div class="examLeft">
        <div class="scollBox box8" style="">
          <div style="" class="box9">
            <div style="" class="box10"></div>

            <div style="" class="box11">题目列表</div>
          </div>

          <!-- 单选题 -->
          <div>
            <div class="box13"></div>

            <div class="danBox">
              <div
                v-for="(item, index) in tiMuList"
                :key="item.id"
                :class="item.z ? 'color7 box14' : swiperIndex == index && !item.z ? 'color5 box14' : 'color6 box14'"
                @click="toSn(index)"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <!-- 单选题end -->
        </div>
        <div class="optionTips">
          <div class="yuan box24"></div>
          <div class="box16">未答</div>
          <div class="yuan box25" style="background: #5ad068"></div>
          <div class="box16">进行</div>
          <div class="yuan box25" style="background: #4275f5"></div>
          <div class="box16">已答</div>
        </div>
      </div>
      <!-- 题目选项模块 -->
      <div class="examCenter">
        <swiper id="swiper" ref="mySwiper" class="swiper swiper-no-swiping">
          <swiper-slide :key="deleNum">
            <!-- 单选题 -->
            <div v-if="tiMuInfo.type == '单选'" style="display: flex">
              <div class="timu">
                <div class="titleTips">单选题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18" :key="num">
                  <div
                    @click="onSelet(idx)"
                    v-for="(data, idx) in tiMuInfo.examQueOption"
                    :key="data.id"
                    :class="data.selected == 'true' ? 'seletXuan xuan' : 'xuan'"
                  >
                    <div class="xxBox">
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div v-if="data.selected == 'true'">
                        <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                      </div>
                    </div>
                    <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>

                <div :key="numKey">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx" :key="numKey">
                    <div>
                      正确答案：{{
                        tiMuInfo.asw == '0'
                          ? 'A'
                          : tiMuInfo.asw == '1'
                          ? 'B'
                          : tiMuInfo.asw == '2'
                          ? 'C'
                          : tiMuInfo.asw == '3'
                          ? 'D'
                          : tiMuInfo.asw == '4'
                          ? 'E'
                          : tiMuInfo.asw == '5'
                          ? 'F'
                          : tiMuInfo.asw == '6'
                          ? 'G'
                          : 'H'
                      }}
                    </div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
            <!-- 多选题 -->
            <div v-if="tiMuInfo.type == '多选'" style="display: flex">
              <div class="timu">
                <div class="titleTips">多选题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18">
                  <div v-for="(data, idx) in tiMuInfo.examQueOption" :key="data.id">
                    <div @click="onDuoSelet(idx)" :key="num" :class="data.selected == 'true' ? 'seletXuan xuan' : 'xuan'">
                      <div class="xxBox">
                        <div class="box25">
                          <span style="font-family: Bold">{{
                            idx == 0
                              ? 'A'
                              : idx == 1
                              ? 'B'
                              : idx == 2
                              ? 'C'
                              : idx == 3
                              ? 'D'
                              : idx == 4
                              ? 'E'
                              : idx == 5
                              ? 'F'
                              : idx == 6
                              ? 'G'
                              : idx == 7
                              ? 'H'
                              : 'I'
                          }}</span
                          >&emsp;{{ data.opContent }}
                        </div>
                        <div v-if="data.selected == 'true'">
                          <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                        </div>
                      </div>
                      <div class="box17" v-for="(img, idx) in data.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div :key="numKey">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx" :key="numKey">
                    <div>
                      正确答案：<span v-for="(cc, cidx) in tiMuInfo.asw" :key="cidx">
                        <span v-if="cc !== ','">
                          {{
                            cc == '0'
                              ? 'A'
                              : cc == '1'
                              ? 'B'
                              : cc == '2'
                              ? 'C'
                              : cc == '3'
                              ? 'D'
                              : cc == '4'
                              ? 'E'
                              : cc == '5'
                              ? 'F'
                              : cc == '6'
                              ? 'G'
                              : 'H'
                          }}
                        </span>
                      </span>
                    </div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi()">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
            <!-- 判断 -->
            <div v-if="tiMuInfo.type == '判断'" style="display: flex">
              <div class="timu">
                <div class="titleTips">判断题</div>
                <div>{{ swiperIndex + 1 }}: {{ tiMuInfo.content }}</div>
                <div class="box17" v-for="(img, idx) in tiMuInfo.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18" :key="num">
                  <div
                    @click="onPanSelet(idx)"
                    v-for="(data, idx) in tiMuInfo.examQueOption"
                    :key="idx"
                    :class="data.selected == 'true' ? 'seletXuan xuan' : 'xuan'"
                  >
                    <div class="xxBox">
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div v-if="data.selected == 'true'">
                        <img class="seImg" src="../../assets/examImgs/cha@2x.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div :key="numKey" v-if="tiMuInfo.type == '判断'">
                  <div v-if="!tiMuInfo.dajx" style="height: 210px; display: flex; align-items: center">
                    <div class="dajx" @click="lookDa()" :key="numKey">查看答案解析</div>
                  </div>
                  <div class="dajxBox" v-if="tiMuInfo.dajx">
                    <div>正确答案：{{ tiMuInfo.answers == '01' ? '对' : '错' }}</div>
                    <div>答案解析：{{ tiMuInfo.generalfeedback == null ? '暂无解析' : tiMuInfo.generalfeedback }}</div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi()">上一题</div>
                  <div @click="dowTi()" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- 题目选项模块end -->
      <div class="examRight">
        <div class="box30">
          <div class="box31">
            <div class="box32"></div>
            <div class="box33">错题小知识</div>
          </div>
          <div class="box34">
            <div class="fs">
              <div>
                本系统收录的 [{{ tiMuList.length }}] 道错题，错题记录模拟考试和题库练习中未答或者答错的题目。
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="box36">
          <div class="box31">
            <div class="box32"></div>

            <div class="box33">温馨提示</div>
          </div>

          <div class="box37">
            <div>如您需要删除该错题，请点击下方的“删除错题”按钮删除。</div>
            <div class="jtBtn" @click="record">删除错题</div>
            <div class="jtBtn" style="background: #4275f5" @click="allDecord">一键清空</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
import { Loading } from 'element-ui';
import { getMistakes, delMistakes, delUserMistakes } from '../../api/study';
// Import Swiper styles
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examData: [], //题目数据
      swiperIndex: 0, //当前页面的题目索引
      num: 0, //key值重置
      jiandaList: [], //简答题
      shicaoList: [], //阅读理解,阅读理解
      videoWidth: 170,
      videoHeight: 170,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      showImg: false, //截图的图片
      carmerShow: false, //人脸识别组件
      examInfo: {}, //试卷数据
      timeimit: 0, //倒计时
      time: '', //倒计时
      interval: null, //定时器
      isSign: '01', //签到状态
      percentageNum: 0, //已做
      totleNum: 0, //总数
      handInTimer: null, //定时器
      findTimer: null,
      webSocket: null,
      surl: '',
      setIntervalWesocketPush: null, //定时器
      dialogVisible: false,
      isFullScreen: false,
      numKey: 110,
      tiMuInfo: {}, //题目的数据
      queType: '', //练习题类型
      tiMuList: [],
      deleNum: 123, //
      timeAend: [],
      panduanList: [],
      duoxuanList: [],
      danxuanList: [],
      jobCategoryList: [], //工种的下拉筛选
      queryErrInfo: {
        type: '03'
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //赛选时间
    handlTime() {
      console.log(Array.isArray(this.timeAend));
      if (Array.isArray(this.timeAend)) {
        let data = {
          startTime: this.timeAend[0],
          endTime: this.timeAend[1],
          type: this.queryErrInfo.type,
          classCodeId: this.queryErrInfo.classCodeId,
        };
        this.queryErrInfo = data;
        this.getErrorList(data);
      } else {
        this.getErrorList(this.queryErrInfo);
      }
    },
    //切换题库
    handlTab(e) {
      this.getErrorList(this.queryErrInfo);
    },
    handJob(e) {
      this.getErrorList(this.queryErrInfo);
    },
    //获取错题
    getErrorList(data) {
      let loadingInstance = Loading.service({
        lock: true,
        text: '题目加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, .2)'
      });
      //题目接口数据
      let _this = this;
      getMistakes(data).then(res => {
        if (Object.keys(res.data.data.mistakes).length === 0) {
          this.danxuanList = [];
          this.duoxuanList = [];
          this.panduanList = [];
          this.tiMuList = [];
          this.tiMuInfo = {};
          this.$confirm('暂无错题~', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              loadingInstance.close();
            })
            .catch(() => {
              loadingInstance.close();
            });
          return false;
        }
        _this.jobCategoryList = res.data.data.categoryInfo.codeInfoList;
        _this.examData = res.data.data.mistakes;

        //处理数据
        _this.danxuanList = _this.examData.qList_0501 == undefined ? [] : _this.examData.qList_0501;
        if (_this.danxuanList !== undefined) {
          _this.danxuanList.forEach(v => {
            v.type = '单选';
            //分割图片和题目
            let arr = v.content.split('*');
            v.content = arr[0];
            arr.splice(0, 1);
            arr.splice(arr.length - 1, 1);
            v.imgs = arr;
            if (v.z) {
              _this.percentageNum = _this.percentageNum + 1;
            }
            v.examQueOption.forEach(x => {
              let ass = x.opContent.split('*');
              x.opContent = ass[0];
              ass.splice(0, 1);
              ass.splice(ass.length - 1, 1);
              x.imgs = ass;
            });
          });
        }

        _this.duoxuanList = _this.examData.qList_0502 == undefined ? [] : _this.examData.qList_0502;

        if (_this.duoxuanList !== undefined) {
          _this.duoxuanList.forEach(v => {
            v.type = '多选';
            let arr = v.content.split('*');
            v.content = arr[0];
            arr.splice(0, 1);
            arr.splice(arr.length - 1, 1);
            v.imgs = arr;
            if (v.z) {
              _this.percentageNum = _this.percentageNum + 1;
            }
            v.examQueOption.forEach(x => {
              let ass = x.opContent.split('*');
              x.opContent = ass[0];
              ass.splice(0, 1);
              ass.splice(ass.length - 1, 1);
              x.imgs = ass;
            });
          });
        }
        _this.panduanList = _this.examData.qList_0503 == undefined ? [] : _this.examData.qList_0503;

        if (_this.panduanList !== undefined) {
          _this.panduanList.forEach(v => {
            v.type = '判断';
            let arr = v.content.split('*');
            v.content = arr[0];
            arr.splice(0, 1);
            arr.splice(arr.length - 1, 1);
            v.imgs = arr;
            if (v.z) {
              _this.percentageNum = _this.percentageNum + 1;
            }
            if (v.selected == 'true') {
              if (v.answers == '00') {
                v.examQueOption = [
                  {
                    opContent: '对',
                    selected: 'true'
                  },
                  {
                    opContent: '错',
                    selected: 'false'
                  }
                ];
              } else if (v.answers == '01') {
                v.examQueOption = [
                  {
                    opContent: '对',
                    selected: 'false'
                  },
                  {
                    opContent: '错',
                    selected: 'true'
                  }
                ];
              }
            } else {
              v.examQueOption = [
                {
                  opContent: '对',
                  selected: 'false'
                },
                {
                  opContent: '错',
                  selected: 'false'
                }
              ];
            }
          });
        }
        _this.tiMuList = [..._this.danxuanList, ..._this.duoxuanList, ..._this.panduanList];
        _this.tiMuInfo = _this.tiMuList[0];
        _this.toSn(0);
        loadingInstance.close();
      });
    },
    //删除错题
    record() {
      if (this.tiMuInfo.content == undefined) {
        this.$message('您还未有错题')
        return false
      }
      this.$confirm('确定要删除该错题吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delMistakes({ eqId: this.tiMuInfo.eqId }).then(res => {
            if (this.tiMuList.length == 1) {
              // 如果就一题的情况下
              this.danxuanList = [];
              this.duoxuanList = [];
              this.panduanList = [];
              this.tiMuList = [];
              this.tiMuInfo = {};
              this.$confirm('太棒了，恭喜您，暂时还没有错题~', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
              })
                .then(() => {})
                .catch(() => {});
              return;
            }

            // 保存当前索引
            const currentIndex = this.swiperIndex;

            // 从数组中删除当前题目
            this.tiMuList.splice(currentIndex, 1);

            // 处理索引和题目显示
            if (this.tiMuList.length === 0) {
              // 如果删除后没有题目了
              this.tiMuInfo = {};
              this.swiperIndex = 0;
            } else if (currentIndex >= this.tiMuList.length) {
              // 如果删除的是最后一道题，显示前一道题
              this.swiperIndex = this.tiMuList.length - 1;
              this.tiMuInfo = this.tiMuList[this.swiperIndex];
            } else {
              // 删除的不是最后一道题，显示下一道题（索引保持不变，因为数组元素前移了）
              this.tiMuInfo = this.tiMuList[currentIndex];
              // swiperIndex保持不变，因为删除后currentIndex位置就是原来的下一题
            }

            this.deleNum = this.deleNum + 1;
            this.$message.success('删除成功！');
          });
        })
        .catch(() => {});
    },
    //清空
    allDecord() {
      if (this.tiMuInfo.content == undefined) {
        this.$message('您还未有错题')
        return false
      }
      this.$confirm('确定要清空所有错题库吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delUserMistakes().then(res => {
            this.tiMuList = [];
            this.tiMuInfo = {};
            this.$router.back();
            this.$message.success('清空错题库成功！');
          });
        })
        .catch(() => {});
    },
    lookDa() {
      this.tiMuInfo.dajx = true;
      this.numKey = this.numKey + 1;
    },
    //
    goBack() {
      this.$router.replace({
        path: '/studyMain'
      });
    },
    //输入框不能输入的bug
    oninpus(e) {
      this.$forceUpdate();
      //console.log(e);
    },
    //处理考试进度百分比
    percentage() {
      this.totleNum = this.tiMuList.length + this.tiMuList.length + +this.tiMuList.length + this.jiandaList.length + this.shicaoList.length;
    },
    //单选题选择选项
    onSelet(idx) {},

    //多选题选择选项
    onDuoSelet(idx) {},
    //判断题选择选项
    onPanSelet(idx) {},
    //阅读理解子单选题选项
    onzSelet(index, cindex, idx) {},
    //阅读理解子多选题选择选项
    onzDuoSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;
      if (this.shicaoList[index].subList_2[cindex].examQueOption[idx].selected) {
        this.shicaoList[index].subList_2[cindex].examQueOption[idx].selected = false;
        this.shicaoList[index].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_2[cindex].examQueOption.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.num = this.num + 1;
    },
    //题目列表点击事件
    toSn(idx) {
      this.swiperIndex = idx;
      this.tiMuInfo = this.tiMuList[idx];
      console.log(this.tiMuInfo);
    },
    //上一题
    upTi() {
      if (this.swiperIndex !== 0) {
        this.swiperIndex = this.swiperIndex - 1;
        this.tiMuInfo = this.tiMuList[this.swiperIndex];
      }
      window.scrollTo(0, 0);
    },
    //下一题
    dowTi() {
      if (this.swiperIndex == this.tiMuList.length - 1) {
        return false;
      }
      this.swiperIndex = this.swiperIndex + 1;
      this.tiMuInfo = this.tiMuList[this.swiperIndex];
      window.scrollTo(0, 0);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getErrorList({ type: '03' });
  },
  destroyed() {},
  beforeDestroy() {
    //销毁定时器
    clearTimeout(this.setIntervalWesocketPush);
    clearInterval(this.handInTimer);
    clearInterval(this.findTimer);
    clearInterval(this.interval);
    this.handInTimer = null;
    this.findTimer = null;
    this.interval = null;
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.xxBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  .seImg {
    margin-top: 6px;
    width: 24px;
    height: 24px;
  }
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0 !important;
}
.dajxBox {
  width: 480px;
  height: 210px;
  overflow-y: auto;
  color: #5ad068;
  padding: 10px;
  background: rgba(90, 208, 104, 0.1);
  border-radius: 5px;
  font-size: 16px;
  font-family: Medium;
  margin-bottom: 5px;
}
.dajxBox::-webkit-scrollbar {
  width: 4px;
}
.dajxBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.dajxBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.dajx {
  // margin-bottom: 200px;
  border-radius: 5px;
  width: 480px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #4275f5;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.dia {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  font-size: 16px;
  font-family: Regular;
}
.qBtn {
  width: 180px;
  height: 50px;
  background: #4275f5;
  opacity: 1;
  border-radius: 25px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  line-height: 50px;
  margin: 23px auto auto auto;
}
.box1 {
  font-family: Bold;
  font-size: 18px;
  text-align: center;
}
.box2 {
  margin-top: 8px;
}
.box3 {
  margin-top: 28px;
}
.box4 {
  width: 171px;
  height: 171px;
}
.box5 {
  width: 170px;
  height: 170px;
}
.box6 {
  margin-top: 11px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
}
.box7 {
  margin-left: 10px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  opacity: 1;
}
.box8 {
  height: 698px;
  overflow-y: auto;
}
.box9 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box10 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box11 {
  margin-left: 8px;
}
.box12 {
  margin-top: 24px;
  font-family: Medium;
}
.box13 {
  color: #333333;
  font-size: 15px;
}
.box14 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin: 10px 10px 0 0;
}
.box15 {
  margin-top: 24px;
  font-family: Medium;
}
.box16 {
  margin-left: 5px;
}

.box17 {
  margin: 10px auto auto auto;
}
.box18 {
  height: 510px;
  overflow-y: auto;
}
.box19 {
  width: 480px;
}
.box20 {
  height: 220px;
}
.box21 {
  color: #fff;
  background: #507df7;
  border: 0;
  margin-left: 50px;
}
.box22 {
  padding: 5px;
  font-size: 16px;
  color: #272748;
  width: 100%;
  height: auto;
}
.box23 {
  border-radius: 12px;
}
.box24 {
  background: #f1f3f7;
  margin-left: 13px;
}
.box25 {
  margin-left: 12px;
}

.box26 {
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.box27 {
  margin: 0px 5px;
}
.box28 {
  height: 700px;
  overflow-y: auto;
  width: 494px;
}
.box29 {
  font-size: 16px;
  font-family: Regular;
  margin-bottom: 10px;
}
.box30 {
  height: 540px;
  background: #fff;
  padding: 28px 20px;
  border-radius: 12px;
}
.box31 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box32 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box33 {
  margin-left: 8px;
}
.box34 {
  margin-top: 20px;
}
.box35 {
  width: 16px;
  height: 16px;
}
.box36 {
  margin-top: 10px;
  width: 240px;
  height: 300px;
  background: #ffffff;
  border-radius: 12px;
  padding: 28px 20px;
}
.box37 {
  margin-top: 24px;
  font-family: Medium;
  font-size: 14px;
  .jtBtn {
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    background: #f56642;
    border-radius: 12px;
    color: #fff;
    cursor: pointer;
    margin: 30px auto auto auto;
  }
}
.box38 {
  width: 16px;
  height: 16px;
  margin-top: 4px;
}
.box39 {
  margin-left: 4px;
}

.box47 {
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.box48 {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
}
.box49 {
  text-align: center;
  font-size: 18px;
  font-family: Bold;
}
.percentage {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  background: #507cf7;
  border-radius: 10px;
  z-index: 1;
}
.digSHowBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .cameraBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 380px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 25px;
    font-family: Medium;
    font-size: 16px;
    .bkBox {
      width: 172px;
      height: 172px;
      margin: 0 auto;
      position: relative;
      .bk {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .camerBtn {
      width: 180px;
      height: 50px;
      background: #4275f5;
      opacity: 1;
      border-radius: 25px;
      font-family: Medium;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin: 28px auto auto auto;
    }
  }
}
.camera_outer {
  position: relative;
  overflow: hidden;
  // background: url("../../assets/img/user_0608_04.png") no-repeat center;
  background-size: 100%;

  video,
  canvas,
  .tx_img {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .btn_camera {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }

  .bg_r_img {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .img_bg_camera {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    img {
      width: 300px;
      height: 300px;
    }

    .img_btn_camera {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      color: #ffffff;

      .loding_img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.header {
  width: 100%;
  height: 60px;
  background: url('../../assets/listImgs/head_bc@2x.png') 100% 100%;
  padding: 0 20px;
  line-height: 60px;
  font-family: Medium;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 18px;
  position: relative;
  padding: 0 100px;
  .timeBox {
  display: flex;
  align-items: center;
  }
  .jobBox {
    position: absolute;
    right: 90px;
    top: 0px;
    display: flex;
    align-items: center;
  }
  .time {
    width: 220px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 31px;
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;

  }
}

.examBanner {
  margin-top: 15px;
  padding: 0 100px;
  display: flex;
  background: rgb(240, 243, 247);
  .examLeft {
    width: 240px;
    height: 850px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    padding: 28px 20px;

    .danBox {
      display: flex;
      flex-wrap: wrap;
      font-family: Medium;
      font-size: 14px;
      .color5 {
        background: #5ad068;
        color: #fff;
        cursor: pointer;
      }
      .color6 {
        background: #f1f3f7;
        color: #8793a4;
        cursor: pointer;
      }
      .color7 {
        background: #4275f5;
        color: #fff;
        cursor: pointer;
      }
      div:nth-child(5n) {
        margin-right: 0 !important;
      }
    }
    .optionTips {
      margin-top: 10px;
      width: 200px;
      height: 50px;
      border: 1px solid #8793a4;
      opacity: 1;
      border-radius: 12px;
      display: flex;
      align-items: center;
      color: #666666;
      font-family: Regular;
      font-size: 14px;
      .yuan {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        opacity: 1;
      }
    }
  }
  .examCenter {
    width: 1220px;
    height: 850px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    padding: 20px;
    .timu {
      position: relative;
      width: 650px;
      max-height: 860px;
      background: #f5f7fb;
      opacity: 1;
      border-radius: 12px;
      overflow-y: auto;
      padding: 54px 25px;
      color: #333333;
      font-family: Medium;
      font-size: 26px;
      .titleTips {
        position: absolute;
        top: 0;
        left: 0;
        width: 72px;
        height: 30px;
        background: #59cc62;
        border-radius: 12px 0px 12px 0px;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
      }
    }
    .timu::-webkit-scrollbar {
      width: 4px;
    }
    .timu::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .timu::-webkit-scrollbar-track {
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
    .xuanx {
      margin-left: 35px;
      .xuan {
        width: 480px;
        min-height: 60px;
        background: #f5f7fb;
        opacity: 1;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        font-size: 22px;
        font-family: Regular;
        cursor: pointer;
        margin-bottom: 20px;
      }
      .seletXuan {
        background: rgba(255, 94, 94, 0.1) !important;
        color: #ff5e5e !important;
      }
      .switchBox {
        display: flex;
        margin-left: 55px;
        .btn {
          width: 160px;
          height: 50px;
          border: 1px solid #4275f5;
          opacity: 1;
          border-radius: 25px;
          cursor: pointer;
          text-align: center;
          line-height: 50px;
          font-family: Medium;
          font-size: 16px;
        }
      }
    }
  }
  .examRight {
    width: 240px;
    height: 850px;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    .fs {
      font-family: Regular;
      font-size: 14px;
      color: #666666;
      line-height: 23px;
      height: 350px;
    }
    .qd {
      margin-left: 20px;
      margin-top: 30px;
      width: 160px;
      height: 50px;
      background: #d3d3d3;
      opacity: 1;
      border-radius: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
    .submit {
      margin-left: 20px;
      margin-top: 42px;
      width: 160px;
      height: 50px;
      background: #fe5f5e;
      box-shadow: 0px 3px 6px rgba(254, 95, 94, 0.31);
      opacity: 1;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
  }
}
</style>
